module.exports = __webpack_public_path__ + "static/media/database-time2.659e23a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/database-time2.svg
// module id = 2717
// module chunks = 7